import styled from './DesktopTop.module.scss'
// import Logo from '../../assets/logo.svg'

const DesktopTop = () => {

  return (
    <div className={styled.wrapper}>
      {/* <img src={Logo} /> */}
      <div className={styled.wrapper_steps}>
        <div className={styled.step}>
          <div className={styled.step_number}>
            1
          </div>
          <div className={styled.step_title}>
            Rellene el formulario y reciba una decisión en 15 minutos
          </div>
        </div>
        <div className={styled.step}>
          <div className={styled.step_number}>
            2
          </div>
          <div className={styled.step_title}>
            Elige las condiciones adecuadas para ti
          </div>
        </div>
        <div className={styled.step}>
          <div className={styled.step_number}>
            3
          </div>
          <div className={styled.step_title}>
            Recibe el dinero en tu
            cuenta bancaria
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopTop